import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "", as = "div", y = 24 }) {
  const C = motion[as];
  return (
    <C className={className} initial={{ opacity: 0, y }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.7, delay, ease: [0.2, 0.7, 0.1, 1] }}>
      {children}
    </C>
  );
}

export function SectionLabel({ n, children, dark }) {
  return (
    <p className={`eyebrow flex items-center gap-3 ${dark ? "text-gold" : "text-gold-deep"}`}>
      <span className={dark ? "text-zinc-400" : "text-mute"}>{n}</span>
      <span className={`h-px w-8 ${dark ? "bg-zinc-600" : "bg-line"}`} />
      {children}
    </p>
  );
}
